export default __webpack_public_path__ + "static/media/F0003.7e59a051.png";